Object.defineProperty(exports, '__esModule', {
  value: true
});
const REACT_RENDER_OP = 'ui.react.render';
const REACT_UPDATE_OP = 'ui.react.update';
const REACT_MOUNT_OP = 'ui.react.mount';
exports.REACT_MOUNT_OP = REACT_MOUNT_OP;
exports.REACT_RENDER_OP = REACT_RENDER_OP;
exports.REACT_UPDATE_OP = REACT_UPDATE_OP;